export default __webpack_public_path__ + "static/talinni-a49b48daf81a54537affb7668fa91df9.png";